<template>
    <div class="form-group">
        <label v-show="label">{{ label }}</label>
        <textarea class="form-control"
                  :rows="rows"
                  :columns="columns"
                  :value="value"
                  @click="$emit('click')"
                  :disabled="disabled"
                  @input="$emit('input',$event.target.value)">
        </textarea>
    </div>
</template>

<script>
    export default {
        name: "TextAreaInput",
        props: {
            label: {
                type: String,
            },
            rows: {
                type: String,
                default: '10'
            },
            columns: {
                type: String,
                default: '5',
            },
            value: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
    }
</script>

<style scoped>

</style>
